import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=704d5a1a&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=ts"
export * from "./LeftMenu.vue?vue&type=script&lang=ts"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=704d5a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d5a1a",
  null
  
)

export default component.exports